module.exports = __webpack_public_path__ + "img/hr-steam-turbine-H.95d2d11b.png";